import { INSIGHTS_TIKTOK_ALL_ATTRIBUTES_AND_METRICS_GLOSSARY } from './tiktok/metric.js';
export const INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_METRICS = [
    'wizardHookScore',
    'wizardHoldScore',
    'wizardClickScore',
    'wizardBuyScore',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_CORE_METRICS = [
    'addToCartToPurchaseRatio',
    'avgOrderValue',
    'canvasAvgViewPercent',
    'canvasAvgViewTime',
    'clicks',
    'clickThroughRateAll',
    'clickThroughRateLinks',
    'clickThroughRateUnique',
    'clickThroughRateUniqueLinks',
    'clickThroughRateUniqueOutbound',
    'conversions',
    'costPerInlineLinkClick',
    'costPerInlinePostEngagement',
    'costPerOutboundClick',
    'costPerThruplay',
    'costPerUniqueClick',
    'costPerUniqueLinkClick',
    'costPerUniqueOutboundClick',
    'costPerVideoThruplay',
    'cpc',
    'cpm',
    'cpp',
    'cpr',
    'ctr',
    'engagement',
    'frequency',
    'fullViewImpressions',
    'fullViewReach',
    'holdplay',
    'holdRate',
    'impressions',
    'inlineLinkClickCtr',
    'inlineLinkClicks',
    'interest',
    'outboundClicks',
    'outboundClicksCtr',
    'reach',
    'roas',
    'spend',
    'thruplay',
    'thruplayClickThroughRate',
    'thumbstop',
    'thumbstopRatio',
    'video15Sec3SecVideoRetention',
    'video25PercentWatchedViews',
    'video30SecWatchedViews',
    'video50PercentWatchedViews',
    'video75PercentWatchedViews',
    'video95PercentWatchedViews',
    'video100PercentWatchedViews',
    'videoAvgTimeWatched',
    'videoPlays',
    'clickToAddToCartRatio',
    'clickToRegistrationCompletedRatio',
    'clickToPurchaseRatio',
    'clickToPurchaseRatioUnique',
    'firstFrameRetention',
    'purchasesPerMille',
    'revenuePerMille',
    'installsPerMille',
    'video2SecondContinuousPlays',
    'costPerVideo2SecondContinuousPlay',
    'uniqueClicks',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_COMPUTED_METRICS = [
    'spendPercentage',
    'purchaseValuePercentage',
    'engagementRate',
    'seeMoreRate',
    'clickToConversionRatio',
    'clickToTrialStartedRatio',
    'clickToSubscriptionsRatio',
    'clickToContactRatio',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_STANDARD_METRICS = [
    ...INSIGHTS_FACEBOOK_TIME_SERIES_CORE_METRICS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_METRICS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_COMPUTED_METRICS,
];
/**
 * @deprecated These are now action metrics and should be removed soon.
 */
export const INSIGHTS_FACEBOOK_TIME_SERIES_DEPRECATED_CORE_METRICS = [
    'addToCarts',
    'appInstalls',
    'costPerAddToCarts',
    'costPerAppInstall',
    'costPerLead',
    'costPerLinkClick',
    'costPerPurchase',
    'leads',
    'linkClicks',
    'purchase',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS = [
    'adCreatedAt',
    'adEndAt',
    'adStartAt',
    'adUpdatedAt',
];
/**
 * Queryable string-type facets of Insights Facebook ads.
 */
export const INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_FIELDS = [
    'campaignName',
    'adSetName',
    'adName',
    'adHeadline',
    'adCopy',
    'landingPage',
];
/**
 * Queryable enumerable (fixed choice) facets of Insights Facebook ads.
 */
export const INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_OPTION_FIELDS = [
    'creativeType',
    'effectiveStatus',
];
const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_SINGULAR_PLATFORM_METRICS = [
    'add_payment_info',
    // Mobile App Feature Unlocks
    'app_custom_event.fb_mobile_achievement_unlocked',
    // Mobile App Starts
    'app_custom_event.fb_mobile_activate_app',
    // Mobile App Payment Details
    'app_custom_event.fb_mobile_add_payment_info',
    // Mobile App Adds To Cart
    'app_custom_event.fb_mobile_add_to_cart',
    // Mobile App Adds to Wishlist
    'app_custom_event.fb_mobile_add_to_wishlist',
    // Adds To Wishlist
    'add_to_wishlist',
    // Mobile App Registrations
    'app_custom_event.fb_mobile_complete_registration',
    // Mobile App Content Views
    'app_custom_event.fb_mobile_content_view',
    // Mobile App Checkouts
    'app_custom_event.fb_mobile_initiated_checkout',
    // Mobile App Achievements
    'app_custom_event.fb_mobile_level_achieved',
    // Mobile App Purchases
    'app_custom_event.fb_mobile_purchase',
    // Mobile App Ratings
    'app_custom_event.fb_mobile_rate',
    // Mobile App Searchs
    'app_custom_event.fb_mobile_search',
    // Mobile App Credit Spends
    'app_custom_event.fb_mobile_spent_credits',
    // Mobile App Tutorial Completions
    'app_custom_event.fb_mobile_tutorial_completion',
    // Other Mobile App Actions
    'app_custom_event.other',
    // App Installs
    'app_install',
    // App Uses
    'app_use',
    // Check-ins
    'checkin',
    // Post Comments
    'comment',
    // Completed Registrations
    'complete_registration',
    // Credit Spends
    'credit_spent',
    // Game Plays
    'games.plays',
    // Landing Page Views
    'landing_page_view',
    // Initiates Checkout
    'initiate_checkout',
    // Page Likes
    'like',
    // Link Clicks
    'link_click',
    // Outbound clicks
    'outbound_click',
    // Mobile App Installs
    'mobile_app_install',
    // Adds Payment Info
    'offsite_conversion.fb_pixel_add_payment_info',
    // Adds To Cart
    'offsite_conversion.fb_pixel_add_to_cart',
    // Adds To Wishlist
    'offsite_conversion.fb_pixel_add_to_wishlist',
    // Completed Registration
    'offsite_conversion.fb_pixel_complete_registration',
    // Custom pixel events defined by the advertiser
    'offsite_conversion.fb_pixel_custom',
    // Initiates Checkout
    'offsite_conversion.fb_pixel_initiate_checkout',
    // Leads
    'offsite_conversion.fb_pixel_lead',
    // Purchases
    'offsite_conversion.fb_pixel_purchase',
    // Searchs
    'offsite_conversion.fb_pixel_search',
    // Views Content
    'offsite_conversion.fb_pixel_view_content',
    // On-Facebook Workflow Completions
    'onsite_conversion.flow_complete',
    // Blocked Messaging Conversations
    'onsite_conversion.messaging_block',
    // Messaging Conversations Started
    'onsite_conversion.messaging_conversation_started_7d',
    // New Messaging Conversations
    'onsite_conversion.messaging_first_reply',
    // Messaging Subscriptions
    'onsite_conversion.messaging_user_subscribed',
    // Post Saves
    'onsite_conversion.post_save',
    // On-Facebook Purchases
    'onsite_conversion.purchase',
    // Total Messaging Connections
    'onsite_conversion.total_messaging_connection',
    // On-Facebook Web Leads
    'onsite_web_lead',
    // Outbound Clicks
    // 'outbound_click',
    // Page Photo Views
    'photo_view',
    // Post Shares
    'post',
    // Post Reactions
    'post_reaction',
    // Event Responses
    'rsvp',
    // 3-Second Video Views
    'video_view',
    // Contacts
    'contact_total',
    // Website Contacts
    'contact_website',
    // Mobile App Contacts
    'contact_mobile_app',
    // Offline Contacts
    'contact_offline',
    // Products Customized
    'customize_product_total',
    // Website Products Customized
    'customize_product_website',
    // Mobile App Products Customized
    'customize_product_mobile_app',
    // Offline Products Customized
    'customize_product_offline',
    // Donations
    'donate_total',
    // Website Donations
    'donate_website',
    // On Facebook Donations
    'donate_on_facebook',
    // Mobile App Donations
    'donate_mobile_app',
    // Offline Donations
    'donate_offline',
    // Location Searches
    'find_location_total',
    // Website Location Searches
    'find_location_website',
    // Mobile App Location Searches
    'find_location_mobile_app',
    // Offline App Location Searches
    'find_location_offline',
    // Appointments Scheduled
    'schedule_total',
    // Website Appointments Scheduled
    'schedule_website',
    // Mobile App Appointments Scheduled
    'schedule_mobile_app',
    // Offline App Appointments Scheduled
    'schedule_offline',
    // Trials Started
    'start_trial_total',
    // Website Trials Started
    'start_trial_website',
    // Mobile App Trials Started
    'start_trial_mobile_app',
    // Offline Trials Started
    'start_trial_offline',
    // Applications Submitted
    'submit_application_total',
    // Website Applications Submitted
    'submit_application_website',
    // Mobile App Applications Submitted
    'submit_application_mobile_app',
    // Offline Applications Submitted
    'submit_application_offline',
    // On Facebook Applications Submitted
    'submit_application_on_facebook',
    // Subscriptions
    'subscribe_total',
    // Website Subscriptions
    'subscribe_website',
    // Mobile App Subscriptions
    'subscribe_mobile_app',
    // Offline Subscriptions
    'subscribe_offline',
    // Recurring Subscription Payments
    'recurring_subscription_payment_total',
    // Website Recurring Subscription Payments
    'recurring_subscription_payment_website',
    // Mobile App Recurring Subscription Payments
    'recurring_subscription_payment_mobile_app',
    // Offline Recurring Subscription Payments
    'recurring_subscription_payment_offline',
    // Canceled Subscriptions
    'cancel_subscription_total',
    // Website Canceled Subscriptions
    'cancel_subscription_website',
    // Mobile App Canceled Subscriptions
    'cancel_subscription_mobile_app',
    // Offline Canceled Subscriptions
    'cancel_subscription_offline',
    // In-App Ad Clicks
    'ad_click_mobile_app',
    // In-App Ad Impressions
    'ad_impression_mobile_app',
    // Estimated Call Confirmation Clicks
    'click_to_call_call_confirm',
    // Calls Placed (Only available in select countries)
    'click_to_call_native_call_placed',
    // 20s Calls Placed (Only available in select countries)
    'click_to_call_native_20s_call_connect',
    // 60s Calls Placed (Only available in select countries)
    'click_to_call_native_60s_call_connect',
];
const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_CROSS_PLATFORM_METRICS = [
    // Page Engagement
    'page_engagement',
    // Post Engagement
    'post_engagement',
    // All On-Facebook Leads
    'onsite_conversion.lead_grouped',
    // All offsite leads plus all On-Facebook leads
    'lead',
    // On-Facebook leads coming from Messenger and Instant Forms
    'leadgen_grouped',
    // App Installs
    'omni_app_install',
    // Purchases
    'omni_purchase',
    // Adds to Cart
    'omni_add_to_cart',
    // Registrations Completed
    'omni_complete_registration',
    // Content Views
    'omni_view_content',
    // Searches
    'omni_search',
    // Checkouts Initiated
    'omni_initiated_checkout',
    // Achievements Unlocked
    'omni_achievement_unlocked',
    // App Activations
    'omni_activate_app',
    // Levels Achieved
    'omni_level_achieved',
    // Ratings Submittedf
    'omni_rate',
    // Credit Spends
    'omni_spend_credits',
    // Tutorials Completed
    'omni_tutorial_completion',
    // Custom Events
    'omni_custom',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_METRICS = [
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_SINGULAR_PLATFORM_METRICS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_CROSS_PLATFORM_METRICS,
];
const INSIGHTS_FACEBOOK_TIME_SERIES_UNIQUABLE_ACTION_METRICS = [
    'link_click',
    'onsite_conversion.messaging_first_reply',
    'outbound_click',
];
const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_UNIQUE_METRICS = INSIGHTS_FACEBOOK_TIME_SERIES_UNIQUABLE_ACTION_METRICS.flatMap((x) => [`action:unique:${x}`, `action:cost_per_unique:${x}`]);
export const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_METRICS_AND_SUBVALUES = [
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_METRICS.flatMap((x) => [
        `action:total:${x}`,
        `action:cost_per:${x}`,
        `action:value:${x}`,
    ]),
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_UNIQUE_METRICS,
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_ALL_METRICS = [
    ...INSIGHTS_FACEBOOK_TIME_SERIES_STANDARD_METRICS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_FIELDS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_DATE_FIELDS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_OPTION_FIELDS,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_METRICS_AND_SUBVALUES,
    'tag',
];
export const INSIGHTS_FACEBOOK_TIME_SERIES_FIELD_TO_COLUMN_MAPPING = {
    /** begin @deprecated metrics */
    addToCarts: 'add_to_carts',
    appInstalls: 'app_installs',
    costPerAddToCarts: 'cost_per_add_to_carts',
    costPerAppInstall: 'cost_per_app_install',
    costPerLead: 'cost_per_lead',
    costPerLinkClick: 'cost_per_link_click',
    costPerPurchase: 'cost_per_purchase',
    leads: 'leads',
    linkClicks: 'link_clicks',
    purchase: 'purchase',
    /** end deprecated metrics */
    avgOrderValue: 'avg_order_value',
    clicks: 'clicks',
    clickThroughRateAll: 'click_through_rate_all',
    clickThroughRateLinks: 'click_through_rate_links',
    clickThroughRateUnique: 'click_through_rate_unique',
    clickThroughRateUniqueLinks: 'click_through_rate_unique_links',
    clickThroughRateUniqueOutbound: 'click_through_rate_unique_outbound',
    conversions: 'conversions',
    costPerOutboundClick: 'cost_per_outbound_click',
    costPerThruplay: 'cost_per_thruplay',
    costPerUniqueOutboundClick: 'cost_per_unique_outbound_click',
    costPerVideoThruplay: 'cost_per_video_thruplay',
    cpc: 'cpc',
    cpm: 'cpm',
    cpp: 'cpp',
    cpr: 'cpr',
    ctr: 'ctr',
    engagement: 'engagement',
    frequency: 'frequency',
    holdplay: 'holdplay',
    holdRate: 'hold_rate',
    impressions: 'impressions',
    interest: 'interest',
    outboundClicks: 'outbound_clicks',
    outboundClicksCtr: 'outbound_clicks_ctr',
    reach: 'reach',
    roas: 'roas',
    spend: 'spend',
    thruplay: 'thruplay',
    thruplayClickThroughRate: 'thruplay_click_through_rate',
    thumbstop: 'thumbstop',
    thumbstopRatio: 'thumbstop_ratio',
    videoAvgTimeWatched: 'video_avg_time_watched',
    videoPlays: 'video_plays',
    video100PercentWatchedViews: 'video_100_percent_watched_views',
    video15Sec3SecVideoRetention: 'video_15_sec_3_sec_video_retention',
    video25PercentWatchedViews: 'video_25_percent_watched_views',
    video30SecWatchedViews: 'video_30_sec_watched_views',
    video50PercentWatchedViews: 'video_50_percent_watched_views',
    video75PercentWatchedViews: 'video_75_percent_watched_views',
    video95PercentWatchedViews: 'video_95_percent_watched_views',
    wizardHookScore: 'wizard_hook_score',
    wizardHoldScore: 'wizard_hold_score',
    wizardClickScore: 'wizard_click_score',
    wizardBuyScore: 'wizard_buy_score',
    canvasAvgViewPercent: 'canvas_avg_view_percent',
    canvasAvgViewTime: 'canvas_avg_view_time',
    costPerUniqueClick: 'cost_per_unique_click',
    costPerInlineLinkClick: 'cost_per_inline_link_click',
    fullViewImpressions: 'full_view_impressions',
    fullViewReach: 'full_view_reach',
    inlineLinkClickCtr: 'inline_link_click_ctr',
    inlineLinkClicks: 'inline_link_clicks',
    costPerInlinePostEngagement: 'cost_per_inline_post_engagement',
    clickToPurchaseRatio: 'click_to_purchase_ratio',
    clickToRegistrationCompletedRatio: 'click_to_registration_completed_ratio',
    clickToPurchaseRatioUnique: 'click_to_purchase_ratio_unique',
    firstFrameRetention: 'first_frame_retention',
    purchasesPerMille: 'purchases_per_mille',
    revenuePerMille: 'revenue_per_mille',
    installsPerMille: 'installs_per_mille',
    addToCartToPurchaseRatio: 'add_to_cart_to_purchase_ratio',
    clickToAddToCartRatio: 'click_to_add_to_cart_ratio',
    spendPercentage: 'spend_percentage',
    purchaseValuePercentage: 'purchase_value_percentage',
    video2SecondContinuousPlays: 'video_2_second_continuous_plays',
    costPerVideo2SecondContinuousPlay: 'cost_per_video_2_second_continuous_play',
    costPerUniqueLinkClick: 'cost_per_unique_link_click',
    uniqueClicks: 'unique_clicks',
    seeMoreRate: 'see_more_rate',
    engagementRate: 'engagement_rate',
    clickToConversionRatio: 'click_to_conversion_ratio',
    clickToTrialStartedRatio: 'click_to_trial_started_ratio',
    clickToSubscriptionsRatio: 'click_to_subscriptions_ratio',
    clickToContactRatio: 'click_to_contact_ratio',
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_COLUMN_TO_FIELD_MAPPING = {
    /** begin @deprecated metrics */
    add_to_carts: 'addToCarts',
    app_installs: 'appInstalls',
    cost_per_add_to_carts: 'costPerAddToCarts',
    cost_per_app_install: 'costPerAppInstall',
    cost_per_lead: 'costPerLead',
    cost_per_link_click: 'costPerLinkClick',
    cost_per_purchase: 'costPerPurchase',
    leads: 'leads',
    link_clicks: 'linkClicks',
    purchase: 'purchase',
    /** end deprecated metrics */
    avg_order_value: 'avgOrderValue',
    clicks: 'clicks',
    click_through_rate_all: 'clickThroughRateAll',
    click_through_rate_links: 'clickThroughRateLinks',
    click_through_rate_unique: 'clickThroughRateUnique',
    click_through_rate_unique_links: 'clickThroughRateUniqueLinks',
    click_through_rate_unique_outbound: 'clickThroughRateUniqueOutbound',
    conversions: 'conversions',
    cost_per_outbound_click: 'costPerOutboundClick',
    cost_per_thruplay: 'costPerThruplay',
    cost_per_unique_outbound_click: 'costPerUniqueOutboundClick',
    cost_per_video_thruplay: 'costPerVideoThruplay',
    cpc: 'cpc',
    cpm: 'cpm',
    cpp: 'cpp',
    cpr: 'cpr',
    ctr: 'ctr',
    engagement: 'engagement',
    frequency: 'frequency',
    holdplay: 'holdplay',
    hold_rate: 'holdRate',
    impressions: 'impressions',
    interest: 'interest',
    outbound_clicks: 'outboundClicks',
    outbound_clicks_ctr: 'outboundClicksCtr',
    reach: 'reach',
    roas: 'roas',
    spend: 'spend',
    thruplay: 'thruplay',
    thruplay_click_through_rate: 'thruplayClickThroughRate',
    thumbstop: 'thumbstop',
    thumbstop_ratio: 'thumbstopRatio',
    video_avg_time_watched: 'videoAvgTimeWatched',
    video_plays: 'videoPlays',
    video_100_percent_watched_views: 'video100PercentWatchedViews',
    video_15_sec_3_sec_video_retention: 'video15Sec3SecVideoRetention',
    video_25_percent_watched_views: 'video25PercentWatchedViews',
    video_30_sec_watched_views: 'video30SecWatchedViews',
    video_50_percent_watched_views: 'video50PercentWatchedViews',
    video_75_percent_watched_views: 'video75PercentWatchedViews',
    video_95_percent_watched_views: 'video95PercentWatchedViews',
    wizard_hook_score: 'wizardHookScore',
    wizard_hold_score: 'wizardHoldScore',
    wizard_click_score: 'wizardClickScore',
    wizard_buy_score: 'wizardBuyScore',
    canvas_avg_view_percent: 'canvasAvgViewPercent',
    canvas_avg_view_time: 'canvasAvgViewTime',
    cost_per_unique_click: 'costPerUniqueClick',
    cost_per_inline_link_click: 'costPerInlineLinkClick',
    full_view_impressions: 'fullViewImpressions',
    full_view_reach: 'fullViewReach',
    inline_link_click_ctr: 'inlineLinkClickCtr',
    inline_link_clicks: 'inlineLinkClicks',
    cost_per_inline_post_engagement: 'costPerInlinePostEngagement',
    click_to_purchase_ratio: 'clickToPurchaseRatio',
    click_to_registration_completed_ratio: 'clickToRegistrationCompletedRatio',
    click_to_purchase_ratio_unique: 'clickToPurchaseRatioUnique',
    first_frame_retention: 'firstFrameRetention',
    purchases_per_mille: 'purchasesPerMille',
    revenue_per_mille: 'revenuePerMille',
    installs_per_mille: 'installsPerMille',
    add_to_cart_to_purchase_ratio: 'addToCartToPurchaseRatio',
    click_to_add_to_cart_ratio: 'clickToAddToCartRatio',
    spend_percentage: 'spendPercentage',
    purchase_value_percentage: 'purchaseValuePercentage',
    video_2_second_continuous_plays: 'video2SecondContinuousPlays',
    cost_per_video_2_second_continuous_play: 'costPerVideo2SecondContinuousPlay',
    cost_per_unique_link_click: 'costPerUniqueLinkClick',
    unique_clicks: 'uniqueClicks',
    engagement_rate: 'engagementRate',
    see_more_rate: 'seeMoreRate',
    click_to_conversion_ratio: 'clickToConversionRatio',
    click_to_trial_started_ratio: 'clickToTrialStartedRatio',
    click_to_subscriptions_ratio: 'clickToSubscriptionsRatio',
    click_to_contact_ratio: 'clickToContactRatio',
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_STANDARD_REFERENCE = {
    /** begin @deprecated metrics */
    addToCarts: {
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Add-To-Carts',
        accumulation: 'sum',
        enabled: true,
        definition: 'The number of times people added items to their shopping cart after clicking on your ad.',
    },
    appInstalls: {
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'App Installs',
        accumulation: 'sum',
        enabled: true,
        definition: 'The number of times your app was installed as a result of your ads.',
    },
    costPerAddToCarts: {
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Add To Cart',
        enabled: true,
        accumulation: 'weightedAverage',
        definition: 'The cost per add-to-cart as a result of your ads.',
    },
    costPerAppInstall: {
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per App Install',
        enabled: true,
        accumulation: 'weightedAverage',
        definition: 'The cost per app install as a result of your ads.',
    },
    costPerLead: {
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Lead',
        enabled: true,
        accumulation: 'weightedAverage',
        definition: 'The cost per lead generated as a result of your ads.',
    },
    costPerLinkClick: {
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (Links)',
        enabled: true,
        accumulation: 'weightedAverage',
        definition: 'The cost per link click made as a result of your ads.',
    },
    costPerPurchase: {
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Purchase',
        enabled: true,
        synonyms: 'cost,purchases',
        accumulation: 'weightedAverage',
        definition: 'The cost per purchase made as a result of your ads.',
    },
    leads: {
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Leads',
        enabled: true,
        synonyms: 'form,submission',
        accumulation: 'sum',
        definition: 'The number of leads generated from your ads, typically through form submissions.',
    },
    linkClicks: {
        formatting: 'numeric',
        higherIs: 'positive',
        accumulation: 'sum',
        label: 'Clicks (Links)',
        enabled: true,
        definition: 'The number of clicks on links within the ad that direct to destinations or experiences on or off Facebook.',
    },
    purchase: {
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Purchases',
        enabled: true,
        synonyms: 'purchases',
        accumulation: 'sum',
        definition: 'The number of purchases made as a result of your ads.',
    },
    /** end deprecated metrics */
    addToCartToPurchaseRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Add-to-Cart To Purchase Ratio',
        enabled: true,
        definition: 'The percentage of add to cart actions that resulted in a purchase. <>(Purchases / Add to Carts) * 100<>',
    },
    avgOrderValue: {
        accumulation: {
            sql: `
        CASE WHEN
          SUM((actions_v2->'omni_purchase'->>'total')::numeric) = 0 THEN NULL
        ELSE
          ROUND((SUM((actions_v2->'omni_purchase'->>'value')::numeric) / SUM((actions_v2->'omni_purchase'->>'total')::numeric))::numeric, 2)::float
        END
      `,
        },
        formatting: 'currency',
        higherIs: 'positive',
        label: 'AOV',
        header: 'Average Order Value',
        enabled: true,
        synonyms: 'money,spent,placed',
        definition: 'The average amount of money spent when a customer placed an order that was attributable to your ad. <>Purchases (All) Value / Purchases (All)<>',
    },
    clicks: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Clicks (All)',
        header: 'Clicks (All)',
        enabled: true,
        synonyms: 'likes,comments,shares,link',
        definition: 'The total number of clicks on your ad, including likes, comments, shares, and link clicks.',
    },
    clickThroughRateAll: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (All)',
        header: 'Click Through Rate (All)',
        enabled: true,
        synonyms: 'ctr',
        definition: 'The percentage of all ad impressions that resulted in a click. <>(Clicks (All) / Impressions) * 100<>',
    },
    clickThroughRateLinks: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Links)',
        header: 'Click Through Rate (Links)',
        enabled: true,
        synonyms: 'ctr',
        definition: 'The percentage of all ad impressions that resulted in a link click. <>(Clicks (Links) / Impressions) * 100<>',
    },
    clickThroughRateUnique: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Unique, All)',
        header: 'Click Through Rate (Unique, All)',
        enabled: true,
        synonyms: 'ctr',
        definition: 'The percentage of all ad impressions that resulted in a unique click. <>(Clicks (Unique, All) / Impressions) * 100<>',
    },
    clickThroughRateUniqueLinks: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Unique, Links)',
        header: 'Click Through Rate (Unique, Links)',
        enabled: true,
        synonyms: 'ctr',
        definition: 'The percentage of all ad impressions that resulted in a unique link click. <>(Clicks (Unique, Links) / Impressions) * 100<>',
    },
    clickToConversionRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Conversion Ratio',
        header: 'Click to Conversion Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a conversion. <>(Conversions / Clicks (Links)) * 100<>',
    },
    clickToTrialStartedRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Trial Started Ratio',
        header: 'Click to Trial Started Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a trial started. <>(Trials Started (Total) / Clicks (Links)) * 100<>',
    },
    clickToSubscriptionsRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Subscriptions Ratio',
        header: 'Click to Subscriptions Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a subscription. <>(Subscriptions (Total) / Clicks (Links)) * 100<>',
    },
    clickToContactRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Contact Ratio',
        header: 'Click to Contact Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a contact. <>(Contacts (Total) / Clicks (Links)) * 100<>',
    },
    clickThroughRateUniqueOutbound: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Unique, Outbound)',
        header: 'Click Through Rate (Unique, Outbound)',
        enabled: true,
        synonyms: 'ctr',
        definition: 'The percentage of all ad impressions that resulted in a unique outbound click. <>(Clicks (Unique, Outbound) / Impressions) * 100<>',
    },
    costPerUniqueLinkClick: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (Unique, Links)',
        header: 'Cost Per Click (Unique, Links)',
        enabled: true,
        synonyms: 'cpc',
        definition: 'The average cost for each unique link click. <>Spend / Clicks (Unique, Links)<>',
    },
    conversions: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Conversions',
        enabled: false,
        definition: undefined,
    },
    costPerOutboundClick: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (Outbound)',
        header: 'Cost Per Click (Outbound)',
        enabled: true,
        definition: 'The average cost for each outbound click. <>Spend / Clicks (Outbound)<>',
    },
    costPerThruplay: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Thruplay',
        header: 'Cost Per Thruplay',
        enabled: true,
        definition: 'The average cost for each Thruplay (when your video is watched to completion, or for at least 15 seconds). <>Spend / Thruplays<>',
    },
    costPerUniqueOutboundClick: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (Unique, Outbound)',
        header: 'Cost Per Click (Unique, Outbound)',
        enabled: true,
        definition: 'The average cost for each unique outbound click. <>Spend / Clicks (Unique, Outbound)<>',
    },
    costPerVideoThruplay: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Video Thruplay',
        enabled: true,
        synonyms: 'video,watched,completion,15 seconds',
        definition: 'The average cost for each video ThruPlay. <>Total Spend / Video ThruPlays<>',
    },
    cpc: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (All)',
        header: 'Cost Per Click (All)',
        enabled: true,
        synonyms: 'cost per click',
        definition: 'The average cost for each click. <>Spend / Clicks (All)<>',
    },
    cpm: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPM',
        header: 'Cost Per Mille',
        enabled: true,
        synonyms: 'cost per mille,1000',
        definition: 'The cost per 1,000 ad impressions. <>(Spend / Impressions) * 1,000<>',
    },
    cpp: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Pixel',
        enabled: true,
        synonyms: 'cost per pixel,page view,purchase',
        definition: 'The cost associated with a specific pixel action, such as a page view or purchase.',
    },
    cpr: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Result',
        enabled: false,
        definition: undefined,
    },
    ctr: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR',
        header: 'Click Through Rate',
        enabled: true,
        synonyms: 'click through rate',
        definition: 'The percentage of all ad impressions that resulted in a click. <>(Clicks (All) / Impressions) * 100<>',
    },
    engagement: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Engagement',
        enabled: true,
        synonyms: 'actions,likes,shares,comments,clicks',
        definition: 'The total number of actions people take involving your ads, such as likes, shares, comments, and clicks.',
    },
    engagementRate: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Engagement Rate',
        enabled: true,
        synonyms: 'engagement,engagement rate',
        definition: 'The percentage of people who engaged with the ad after viewing it',
    },
    frequency: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'neutral',
        label: 'Frequency',
        header: 'Frequency',
        enabled: true,
        synonyms: 'people,saw',
        definition: 'The average number of times that each unique viewer of your ad saw your ad.',
    },
    holdplay: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Thruplay Rate',
        header: 'Thruplay Rate',
        enabled: true,
        synonyms: 'thruplay,watched,video,15 seconds',
        definition: 'The percentage of video views that lasted for at least 15 seconds. <>(Thruplays / Video Views (All)) * 100<>',
    },
    holdRate: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Hold Rate',
        header: 'Holdplay Rate',
        enabled: true,
        synonyms: 'watched,video,15 seconds',
        definition: 'The percentage of impressions that resulted in a video view, lasting for at least 15 seconds. <>(Thruplays / Impressions) * 100<>',
    },
    impressions: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Impressions',
        header: 'Impressions',
        enabled: true,
        synonyms: 'displayed,screen',
        definition: 'The number of times that your ads were on-screen.',
    },
    interest: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Interest',
        enabled: true,
        synonyms: 'clicks,likes,comments',
        definition: 'The level of interest shown by users, often measured by actions like clicks, likes, and comments.',
    },
    outboundClicks: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Clicks (Outbound)',
        header: 'Clicks (Outbound)',
        enabled: true,
        definition: 'The number of clicks on links that lead to destinations outside Meta.',
    },
    outboundClicksCtr: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Outbound)',
        header: 'Click Through Rate (Outbound)',
        enabled: true,
        synonyms: 'click through rate',
        definition: 'The percentage of all ad impressions that resulted in an outbound click. <>(Clicks (Outbound) / Impressions) * 100<>',
    },
    reach: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Reach',
        header: 'Reach',
        enabled: true,
        synonyms: 'raw',
        definition: 'The number of unique viewers that saw your ads at least once. Reach is different from impressions, which may include multiple views of your ads by the same end viewer.',
    },
    roas: {
        accumulation: {
            sql: `
        CASE WHEN SUM(spend) = 0
          THEN NULL
        ELSE
          ROUND((SUM((actions_v2->'omni_purchase'->>'value')::numeric) / SUM(spend))::numeric, 2)::float
        END
      `,
        },
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'ROAS',
        header: 'Return On Ad Spend',
        enabled: true,
        synonyms: 'return on ad spend',
        definition: 'The amount of revenue generated that is attributable to your ad, per every dollar spent on your ad. <>Revenue / Spend<>',
    },
    seeMoreRate: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'See More Rate',
        header: 'See More Rate',
        enabled: true,
        synonyms: 'see more, more rate',
        definition: "The percentage of people who clicked on the 'See more' button to expand the copy after viewing the ad",
    },
    spend: {
        accumulation: 'sum',
        formatting: 'currency',
        higherIs: 'neutral',
        label: 'Spend',
        header: 'Spend',
        enabled: true,
        synonyms: 'spent,money',
        definition: 'The total amount of money spent on running your ad.',
    },
    thruplay: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Thruplays',
        header: 'Thruplays',
        enabled: true,
        definition: 'The number of times your video was played to completion, or for at least 15 seconds.',
    },
    thruplayClickThroughRate: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Thruplay)',
        header: 'Click Through Rate (Thruplay)',
        enabled: true,
        definition: 'The percentage of all ad impressions that resulted in a Thruplay (video played to completion, or for at least 15 seconds). <>(Thruplays / Impressions) * 100<>',
    },
    thumbstop: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Thumbstop',
        enabled: false,
        definition: undefined,
    },
    thumbstopRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Thumbstop Rate',
        header: 'Thumbstop Rate',
        enabled: true,
        definition: 'The percentage of impressions that resulted in a thumbstop. <>(Video Plays (3 Second Plays) / Impressions) * 100<>',
    },
    videoAvgTimeWatched: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video Average Play Time',
        header: 'Video Average Play Time',
        enabled: true,
        definition: 'The average amount of time that your video was played for, including any time spent replaying the video within a single impression.',
    },
    videoPlays: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video Plays (All)',
        header: 'Video Plays (All)',
        enabled: true,
        definition: 'The number of times your video started playing.',
    },
    video100PercentWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 100% Watched Views',
        header: 'Video 100% Watched Views',
        enabled: true,
        synonyms: 'complete,completion',
        definition: 'The number of times your video was watched at least 100% of the way through, including plays that skipped to this point.',
    },
    video15Sec3SecVideoRetention: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: '15 Sec/3 Sec Video Retention',
        header: '15 Sec/3 Sec Video Retention',
        enabled: true,
        definition: 'The percentage of viewers who, after having watched your video for at least 3 seconds, continued to watch your video until the 15 second mark or completion. <>(Thruplays / Video Plays (3 Second Plays)) * 100<>',
    },
    video25PercentWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 25% Watched Views',
        header: 'Video 25% Watched Views',
        enabled: true,
        definition: 'The number of times your video was watched at least 25% of the way through, including plays that skipped to this point.',
    },
    video30SecWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 30 Sec Watched Views',
        enabled: true,
        definition: 'The number of times your video was watched for at least 30 seconds.',
    },
    video50PercentWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 50% Watched Views',
        header: 'Video 50% Watched Views',
        enabled: true,
        definition: 'The number of times your video was watched at least 50% of the way through, including plays that skipped to this point.',
    },
    video75PercentWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 75% Watched Views',
        header: 'Video 75% Watched Views',
        enabled: true,
        definition: 'The number of times your video was watched at least 75% of the way through, including plays that skipped to this point.',
    },
    video95PercentWatchedViews: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Video 95% Watched Views',
        header: 'Video 95% Watched Views',
        enabled: true,
        definition: 'The number of times your video was watched at least 95% of the way through, including plays that skipped to this point.',
    },
    wizardHookScore: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'neutral',
        label: 'Hook Score',
        enabled: true,
        definition: undefined,
    },
    wizardHoldScore: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'neutral',
        label: 'Hold Score',
        enabled: true,
        definition: undefined,
    },
    wizardClickScore: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'neutral',
        label: 'Click Score',
        enabled: true,
        definition: undefined,
    },
    wizardBuyScore: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'neutral',
        label: 'Buy Score',
        enabled: true,
        definition: undefined,
    },
    canvasAvgViewPercent: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Canvas Avg View %',
        enabled: true,
        synonyms: 'instant experience',
        definition: 'The average percentage of the Instant Experience that people saw. An Instant Experience is a screen that opens after someone interacts with your ad on a mobile device. It may include a series of interactive or multimedia components, including video, images product catalog and more.',
    },
    canvasAvgViewTime: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Canvas Avg View Time',
        enabled: true,
        synonyms: 'instant experience',
        definition: 'The average total time, in seconds, that people spent viewing an Instant Experience. An Instant Experience is a screen that opens after someone interacts with your ad on a mobile device. It may include a series of interactive or multimedia components, including video, images product catalog and more.',
    },
    costPerUniqueClick: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'CPC (Unique, All)',
        header: 'Cost Per Click (Unique, All)',
        enabled: true,
        definition: 'The average cost for each unique click.',
    },
    costPerInlineLinkClick: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Inline Link Click',
        enabled: true,
        definition: 'The average cost of each inline link click.',
    },
    fullViewImpressions: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Impressions (Full View)',
        header: 'Impressions (Full View)',
        enabled: true,
        synonyms: 'page',
        definition: "The number of times that your ads were on-screen, and 100% of the creative (the entire ad image or video) appears on the viewer's screen. This means that the viewer can see the entire ad without having to scroll or interact with the page to reveal more of it.",
    },
    fullViewReach: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Reach (Full View)',
        header: 'Reach (Full View)',
        enabled: true,
        synonyms: 'page',
        definition: "The number of unique viewers that saw your ads at least once and saw 100% of the ad's creative (image, video, etc.) on screen. This means that the viewer can see the entire ad without having to scroll or interact with the page to reveal more of it.",
    },
    inlineLinkClickCtr: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'CTR (Inline Links)',
        enabled: true,
        definition: 'The percentage of time people saw your ads and performed an inline link click.',
    },
    inlineLinkClicks: {
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        label: 'Clicks (Inline Links)',
        enabled: true,
        definition: 'The number of clicks on links to select destinations or experiences, on or off Facebook-owned properties. Inline link clicks use a fixed 1-day-click attribution window.',
    },
    costPerInlinePostEngagement: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'negative',
        label: 'Cost Per Inline Post Enagagement',
        enabled: true,
        definition: 'The average cost of each inline post engagement.',
    },
    clickToPurchaseRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Purchase Ratio',
        header: 'Click to Purchase Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a purchase. <>(Purchases / Clicks (Links)) * 100<>',
    },
    clickToRegistrationCompletedRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Click To Registration Completed Ratio',
        definition: 'The percentage of clicks that resulted in a completed registration. ',
    },
    clickToAddToCartRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Add-to-Cart Ratio',
        header: 'Click to Add-To-Cart Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in an add-to-cart. <>(Add-To-Carts / Clicks (Links)) * 100<>',
    },
    clickToPurchaseRatioUnique: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Click To Purchase Ratio (Unique)',
        definition: 'The percentage of unique clicks that resulted in a purchase. <>Purchases (All) / Link Clicks (Unique) * 100<>',
    },
    firstFrameRetention: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'First Frame Retention',
        definition: 'The percentage of users who watch a video after seeing the thumbnail. <>Video Plays / Impressions * 100<>',
    },
    purchasesPerMille: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        enabled: true,
        label: 'PPM',
        header: 'Purchases Per Mille',
        definition: 'The number of purchases attributable to your ad, per 1,000 ad impressions. <>Purchases (All)  / Impressions * 1000<>',
    },
    revenuePerMille: {
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'positive',
        enabled: true,
        label: 'RPM',
        header: 'Revenue Per Mille',
        definition: 'The amount of revenue attributable to your ad, per 1,000 ad impressions. <>Purchases (All) Value / Impressions * 1000<>',
    },
    installsPerMille: {
        accumulation: 'weightedAverage',
        formatting: 'numeric',
        higherIs: 'positive',
        enabled: true,
        label: 'IPM',
        header: 'Installs Per Mille',
        definition: 'The number of app installs attributable to your ad, per 1,000 ad impressions. <>App Installs (All) / Impressions * 1000<>',
    },
    spendPercentage: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Spend %',
        definition: 'The percentage of spend allocated to an ad out of total spend. <>Spend / Total Spend Within Time Period * 100<>',
    },
    purchaseValuePercentage: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Purchase Value %',
        definition: 'The percentage of purchase value attributed to a single ad out of total purchase value across your ads. <>Purchases (All) Value / Total Purchases (All) Value Within Time Period * 100<>',
    },
    video2SecondContinuousPlays: {
        label: 'Video Plays (2 Second Plays)',
        accumulation: 'sum',
        formatting: 'numeric',
        enabled: true,
        higherIs: 'positive',
        definition: "The number of times your video was played for at least 2 continuous seconds, or for nearly its total length if it's shorter than 2 seconds.",
    },
    costPerVideo2SecondContinuousPlay: {
        label: 'Cost Per 2 Second Video Play',
        accumulation: 'weightedAverage',
        formatting: 'currency',
        enabled: true,
        higherIs: 'negative',
        definition: 'The average cost for each 2 second continous video play. <>Spend / Video Plays (2 Second Plays)<>',
    },
    uniqueClicks: {
        label: 'Clicks (Unique, All)',
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        enabled: true,
        definition: 'The number of unique viewers that performed a click on the ad.',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_REFERENCE_LOOKUP = {
    add_payment_info: {
        higherIs: 'positive',
        label: 'Add Payment Info',
        enabled: true,
        formatting: 'numeric',
    },
    add_to_wishlist: {
        higherIs: 'positive',
        label: 'Adds To Wishlist',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_achievement_unlocked': {
        higherIs: 'positive',
        label: 'Feature Unlocks (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_activate_app': {
        higherIs: 'positive',
        label: 'App Opened (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_add_payment_info': {
        higherIs: 'positive',
        label: 'Add Payment Info (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_add_to_cart': {
        higherIs: 'positive',
        label: 'Add-To-Carts (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_add_to_wishlist': {
        higherIs: 'positive',
        label: 'Adds to Wishlist (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_complete_registration': {
        higherIs: 'positive',
        label: 'App Registrations (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_content_view': {
        higherIs: 'positive',
        label: 'Content Views (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_initiated_checkout': {
        higherIs: 'positive',
        label: 'Checkouts (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_level_achieved': {
        higherIs: 'positive',
        label: 'Achievements (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_purchase': {
        higherIs: 'positive',
        label: 'Purchases (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_rate': {
        higherIs: 'positive',
        label: 'Ratings (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_search': {
        higherIs: 'positive',
        label: 'Searches (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_spent_credits': {
        higherIs: 'positive',
        label: 'Credit Spends (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.fb_mobile_tutorial_completion': {
        higherIs: 'positive',
        label: 'Mobile App Tutorial Completions (Mobile App)',
        enabled: true,
        formatting: 'numeric',
    },
    'app_custom_event.other': {
        higherIs: 'positive',
        label: 'Other Mobile App Actions',
        enabled: true,
        formatting: 'numeric',
    },
    app_install: {
        higherIs: 'positive',
        label: 'App Installs (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    app_use: {
        higherIs: 'positive',
        label: 'App Uses (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    checkin: {
        higherIs: 'positive',
        label: 'Check-ins',
        enabled: true,
        formatting: 'numeric',
    },
    comment: {
        higherIs: 'positive',
        label: 'Post Comments',
        header: 'Post Comments',
        definition: 'The number of comments on your ad.',
        enabled: true,
        formatting: 'numeric',
    },
    credit_spent: {
        higherIs: 'positive',
        label: 'Credit Spends',
        enabled: true,
        formatting: 'numeric',
    },
    'games.plays': {
        higherIs: 'positive',
        label: 'Game Plays',
        enabled: true,
        formatting: 'numeric',
    },
    initiate_checkout: {
        higherIs: 'positive',
        label: 'Initiates Checkout',
        enabled: true,
        formatting: 'numeric',
    },
    landing_page_view: {
        higherIs: 'positive',
        label: 'Landing Page Views',
        enabled: true,
        formatting: 'numeric',
    },
    like: {
        higherIs: 'positive',
        label: 'Page Follows or Likes',
        header: 'Page Follows or Likes',
        definition: 'The number of follows or likes that you received on your profile that are attributable to your ad.',
        enabled: true,
        formatting: 'numeric',
    },
    link_click: {
        higherIs: 'positive',
        label: 'Clicks (Links)',
        header: 'Clicks (Links)',
        enabled: true,
        formatting: 'numeric',
        definition: 'The number of clicks on links within the ad that direct to destinations on or off Meta',
    },
    mobile_app_install: {
        higherIs: 'positive',
        label: 'Mobile App Installs',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_add_payment_info': {
        higherIs: 'positive',
        label: 'Add Payment Info (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_add_to_cart': {
        higherIs: 'positive',
        label: 'Add-To-Carts (Pixel)',
        enabled: true,
        formatting: 'numeric',
        definition: 'The number of times people added items to their shopping cart after clicking on your ad.',
    },
    'offsite_conversion.fb_pixel_add_to_wishlist': {
        higherIs: 'positive',
        label: 'Adds To Wishlist (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_complete_registration': {
        higherIs: 'positive',
        label: 'Completed Registration (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_custom': {
        higherIs: 'positive',
        label: 'Custom pixel events defined by the advertiser',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_initiate_checkout': {
        higherIs: 'positive',
        label: 'Initiates Checkout (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_lead': {
        higherIs: 'positive',
        label: 'Leads (Offsite)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_purchase': {
        higherIs: 'positive',
        label: 'Purchases (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_search': {
        higherIs: 'positive',
        label: 'Searches (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'offsite_conversion.fb_pixel_view_content': {
        higherIs: 'positive',
        label: 'Views Content (Pixel)',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.flow_complete': {
        higherIs: 'positive',
        label: 'On-Facebook Workflow Completions',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.messaging_block': {
        higherIs: 'positive',
        label: 'Blocked Messaging Conversations',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.messaging_conversation_started_7d': {
        higherIs: 'positive',
        label: 'Messaging Conversations Started',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.messaging_first_reply': {
        higherIs: 'positive',
        label: 'New Messaging Conversations',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.messaging_user_subscribed': {
        higherIs: 'positive',
        label: 'Messaging Subscriptions',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.post_save': {
        higherIs: 'positive',
        label: 'Post Saves',
        header: 'Post Saves',
        definition: 'The number of times that your ad has been saved.',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.purchase': {
        higherIs: 'positive',
        label: 'Purchases (On-Facebook)',
        enabled: true,
        formatting: 'numeric',
    },
    /** @deprecated we use `outboundClicks` on top level insights time series object instead */
    // outbound_click: {
    //   accumulation: 'sum',
    //   formatting: 'numeric',
    //   higherIs: 'positive',
    //   label: 'Outbound Clicks',
    //   enabled: true, formatting: 'numeric'
    // },
    photo_view: {
        higherIs: 'positive',
        label: 'Page Photo Views',
        enabled: true,
        formatting: 'numeric',
    },
    post: {
        higherIs: 'positive',
        label: 'Post Shares',
        header: 'Post Shares',
        definition: 'The number of shares of your ad, including when your ad was shared to Feed, Groups, Instagram Direct and Stories.',
        enabled: true,
        formatting: 'numeric',
    },
    post_reaction: {
        higherIs: 'positive',
        label: 'Post Reactions',
        header: 'Post Reactions',
        definition: 'The number of reactions on your ad (including like, love, care, haha, wow, sad or angry).',
        enabled: true,
        formatting: 'numeric',
    },
    rsvp: {
        higherIs: 'positive',
        label: 'Event Responses',
        enabled: true,
        formatting: 'numeric',
    },
    video_view: {
        higherIs: 'positive',
        label: 'Video Plays (3 Second Plays)',
        header: 'Video Plays (3 Second Plays)',
        enabled: true,
        formatting: 'numeric',
        definition: "The number of times your video was played for at least 3 continuous seconds, or for nearly its total length if it's shorter than 3 seconds.",
    },
    contact_total: {
        higherIs: 'positive',
        label: 'Contacts (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    contact_website: {
        higherIs: 'positive',
        label: 'Contacts (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    contact_mobile_app: {
        higherIs: 'positive',
        label: 'Contacts (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    contact_offline: {
        higherIs: 'positive',
        label: 'Contacts (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    customize_product_total: {
        higherIs: 'positive',
        label: 'Products Customized (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    customize_product_website: {
        higherIs: 'positive',
        label: 'Products Customized (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    customize_product_mobile_app: {
        higherIs: 'positive',
        label: 'Products Customized (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    customize_product_offline: {
        higherIs: 'positive',
        label: 'Products Customized (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    donate_total: {
        higherIs: 'positive',
        label: 'Donations (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    donate_website: {
        higherIs: 'positive',
        label: 'Donations (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    donate_on_facebook: {
        higherIs: 'positive',
        label: 'Donations (On-Facebook)',
        enabled: true,
        formatting: 'numeric',
    },
    donate_mobile_app: {
        higherIs: 'positive',
        label: 'Donations (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    donate_offline: {
        higherIs: 'positive',
        label: 'Donations (Offline App)',
        enabled: true,
        formatting: 'numeric',
    },
    find_location_total: {
        higherIs: 'positive',
        label: 'Location Searches (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    find_location_website: {
        higherIs: 'positive',
        label: 'Location Searches (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    find_location_mobile_app: {
        higherIs: 'positive',
        label: 'Location Searches (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    find_location_offline: {
        higherIs: 'positive',
        label: 'Location Searches (Offline App)',
        enabled: true,
        formatting: 'numeric',
    },
    schedule_total: {
        higherIs: 'positive',
        label: 'Appointments Scheduled (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    schedule_website: {
        higherIs: 'positive',
        label: 'Appointments Scheduled (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    schedule_mobile_app: {
        higherIs: 'positive',
        label: 'Appointments Scheduled (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    schedule_offline: {
        higherIs: 'positive',
        label: 'Appointments Scheduled (Offline App)',
        enabled: true,
        formatting: 'numeric',
    },
    start_trial_total: {
        higherIs: 'positive',
        label: 'Trials Started (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    start_trial_website: {
        higherIs: 'positive',
        label: 'Trials Started (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    start_trial_mobile_app: {
        higherIs: 'positive',
        label: 'Trials Started (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    start_trial_offline: {
        higherIs: 'positive',
        label: 'Trials Started (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    submit_application_total: {
        higherIs: 'positive',
        label: 'Applications Submitted',
        enabled: true,
        formatting: 'numeric',
    },
    submit_application_website: {
        higherIs: 'positive',
        label: 'Applications Submitted (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    submit_application_mobile_app: {
        higherIs: 'positive',
        label: 'Applications Submitted (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    submit_application_offline: {
        higherIs: 'positive',
        label: 'Applications Submitted (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    submit_application_on_facebook: {
        higherIs: 'positive',
        label: 'Applications Submitted (On-Facebook)',
        enabled: true,
        formatting: 'numeric',
    },
    subscribe_total: {
        higherIs: 'positive',
        label: 'Subscriptions (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    subscribe_website: {
        higherIs: 'positive',
        label: 'Subscriptions (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    subscribe_mobile_app: {
        higherIs: 'positive',
        label: 'Subscriptions (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    subscribe_offline: {
        higherIs: 'positive',
        label: 'Subscriptions (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    recurring_subscription_payment_total: {
        higherIs: 'positive',
        label: 'Recurring Subscription Payments (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    recurring_subscription_payment_website: {
        higherIs: 'positive',
        label: 'Recurring Subscription Payments (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    recurring_subscription_payment_mobile_app: {
        higherIs: 'positive',
        label: 'Recurring Subscription Payments (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    recurring_subscription_payment_offline: {
        higherIs: 'positive',
        label: 'Recurring Subscription Payments (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    cancel_subscription_total: {
        higherIs: 'positive',
        label: 'Canceled Subscriptions (Total)',
        enabled: true,
        formatting: 'numeric',
    },
    cancel_subscription_website: {
        higherIs: 'positive',
        label: 'Canceled Subscriptions (Website)',
        enabled: true,
        formatting: 'numeric',
    },
    cancel_subscription_mobile_app: {
        higherIs: 'positive',
        label: 'Canceled Subscriptions (Mobile)',
        enabled: true,
        formatting: 'numeric',
    },
    cancel_subscription_offline: {
        higherIs: 'positive',
        label: 'Canceled Subscriptions (Offline)',
        enabled: true,
        formatting: 'numeric',
    },
    ad_click_mobile_app: {
        higherIs: 'positive',
        label: 'In-App Ad Clicks',
        enabled: true,
        formatting: 'numeric',
    },
    ad_impression_mobile_app: {
        higherIs: 'positive',
        label: 'In-App Ad Impressions',
        enabled: true,
        formatting: 'numeric',
    },
    click_to_call_call_confirm: {
        higherIs: 'positive',
        label: 'Estimated Call Confirmation Clicks',
        enabled: true,
        formatting: 'numeric',
    },
    click_to_call_native_call_placed: {
        higherIs: 'positive',
        label: 'Calls Placed (Select countries)',
        enabled: true,
        formatting: 'numeric',
    },
    click_to_call_native_20s_call_connect: {
        higherIs: 'positive',
        label: '20s Calls Placed (Select countries)',
        enabled: true,
        formatting: 'numeric',
    },
    click_to_call_native_60s_call_connect: {
        higherIs: 'positive',
        label: '60s Calls Placed (Select countries)',
        enabled: true,
        formatting: 'numeric',
    },
    page_engagement: {
        higherIs: 'positive',
        label: 'Page Engagements',
        header: 'Page Engagements',
        definition: 'The number of actions taken on your page / profile or any of your content, attributable to your ad.',
        enabled: true,
        formatting: 'numeric',
    },
    post_engagement: {
        higherIs: 'positive',
        label: 'Post Engagements',
        header: 'Post Engagements',
        enabled: true,
        formatting: 'numeric',
        definition: 'The number of actions that people took involving your ad, including shares, reactions, saves, comments, 3-second video plays, photo views, and link clicks.',
    },
    'onsite_conversion.lead_grouped': {
        higherIs: 'positive',
        label: 'Leads (On-Facebook)',
        enabled: true,
        formatting: 'numeric',
    },
    lead: {
        higherIs: 'positive',
        label: 'Leads (Offsite + On-Facebook)',
        enabled: true,
        formatting: 'numeric',
        synonyms: 'form,submission',
        definition: 'The number of leads generated from your ads, typically through form submissions.',
    },
    leadgen_grouped: {
        higherIs: 'positive',
        label: 'Leads (On-Facebook from Messenger + Instant Forms)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_app_install: {
        higherIs: 'positive',
        label: 'App Installs (All)',
        enabled: true,
        formatting: 'numeric',
        definition: 'The number of times your app was installed as a result of your ads.',
    },
    omni_purchase: {
        higherIs: 'positive',
        label: 'Purchases (All)',
        enabled: true,
        formatting: 'numeric',
        synonyms: 'purchases',
        definition: 'The number of purchases made as a result of your ads.',
    },
    omni_add_to_cart: {
        higherIs: 'positive',
        label: 'Add-To-Carts (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_complete_registration: {
        higherIs: 'positive',
        label: 'Registrations Completed (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_view_content: {
        higherIs: 'positive',
        label: 'Content Views (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_search: {
        higherIs: 'positive',
        label: 'Searches (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_initiated_checkout: {
        higherIs: 'positive',
        label: 'Checkouts Initiated (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_achievement_unlocked: {
        higherIs: 'positive',
        label: 'Achievements Unlocked (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_activate_app: {
        higherIs: 'positive',
        label: 'App Activations (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_level_achieved: {
        higherIs: 'positive',
        label: 'Levels Achieved (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_rate: {
        higherIs: 'positive',
        label: 'Ratings Submitted (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_spend_credits: {
        higherIs: 'positive',
        label: 'Credit Spends (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_tutorial_completion: {
        higherIs: 'positive',
        label: 'Tutorials Completed (All)',
        enabled: true,
        formatting: 'numeric',
    },
    omni_custom: {
        higherIs: 'positive',
        label: 'Custom Events (All)',
        enabled: true,
        formatting: 'numeric',
    },
    complete_registration: {
        higherIs: 'positive',
        label: 'Completed Registrations',
        enabled: true,
        formatting: 'numeric',
    },
    'onsite_conversion.total_messaging_connection': {
        higherIs: 'positive',
        label: 'Total Messaging Connections',
        enabled: true,
        formatting: 'numeric',
    },
    onsite_web_lead: {
        higherIs: 'positive',
        label: 'On-Facebook Web Leads',
        enabled: true,
        formatting: 'numeric',
    },
    outbound_click: {
        higherIs: 'positive',
        label: 'Outbound Clicks',
        enabled: true,
        formatting: 'numeric',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_REFERENCE = {
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_METRICS.reduce((acc, curr) => {
        const coreDefinition = INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_REFERENCE_LOOKUP[curr];
        if (!coreDefinition)
            return acc;
        acc[`action:total:${curr}`] = {
            definition: undefined,
            synonyms: undefined,
            header: undefined,
            ...coreDefinition,
            higherIs: 'positive',
            accumulation: 'sum',
            formatting: 'numeric',
        };
        acc[`action:cost_per:${curr}`] = {
            definition: undefined,
            synonyms: undefined,
            ...coreDefinition,
            label: `Cost Per ${coreDefinition.label}`,
            header: coreDefinition.header
                ? `Cost Per ${coreDefinition.header}`
                : undefined,
            higherIs: 'negative',
            accumulation: 'weightedAverage',
            formatting: 'currency',
        };
        acc[`action:value:${curr}`] = {
            definition: undefined,
            synonyms: undefined,
            ...coreDefinition,
            label: `${coreDefinition.label} Value`,
            header: coreDefinition.header
                ? `${coreDefinition.header} Value`
                : undefined,
            higherIs: 'positive',
            accumulation: 'sum',
            formatting: 'currency',
        };
        return acc;
    }, INSIGHTS_FACEBOOK_TIME_SERIES_UNIQUABLE_ACTION_METRICS.reduce((acc, curr) => {
        const coreDefinition = INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_REFERENCE_LOOKUP[curr];
        if (!coreDefinition)
            return acc;
        acc[`action:unique:${curr}`] = {
            ...coreDefinition,
            label: `${coreDefinition.label} (Unique)`,
            higherIs: 'positive',
            accumulation: 'sum',
            formatting: 'numeric',
        };
        acc[`action:cost_per_unique:${curr}`] = {
            ...coreDefinition,
            label: `Cost Per ${coreDefinition.label} (Unique)`,
            higherIs: 'positive',
            accumulation: 'sum',
            formatting: 'currency',
        };
        return acc;
    }, {})),
    'action:unique:link_click': {
        label: 'Clicks (Unique, Links)',
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        enabled: true,
        header: undefined,
        definition: 'The number of unique viewers that performed a link click on the ad.',
        synonyms: undefined,
    },
    'action:unique:outbound_click': {
        label: 'Clicks (Unique, Outbound)',
        accumulation: 'sum',
        formatting: 'numeric',
        higherIs: 'positive',
        enabled: true,
        header: undefined,
        definition: 'The number of unique viewers that performed an outbound click on the ad.',
        synonyms: undefined,
    },
    'action:cost_per_unique:outbound_click': {
        label: 'Cost Per Click (Unique, Outbound)',
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'positive',
        enabled: true,
        header: undefined,
        definition: 'The average cost for each unique outbound click.',
        synonyms: undefined,
    },
    'action:cost_per_unique:link_click': {
        label: 'Cost Per Click (Unique, Link)',
        accumulation: 'weightedAverage',
        formatting: 'currency',
        higherIs: 'positive',
        enabled: true,
        header: undefined,
        definition: 'The average cost for each unique link click.',
        synonyms: undefined,
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_REFERENCE = {
    campaignName: {
        label: 'Campaign Name',
        synonyms: 'title,label',
        definition: 'The name given to an entire advertising campaign.',
        formatting: 'text',
    },
    adSetName: {
        label: 'Ad Set Name',
        synonyms: 'title,label',
        definition: 'The name given to a group of ads within a campaign.',
        formatting: 'text',
    },
    adName: {
        label: 'Ad Name',
        header: 'Ad Name',
        synonyms: 'title,label',
        definition: 'The name given to an individual ad within an ad set.',
        formatting: 'text',
    },
    adCopy: {
        label: 'Ad Copy',
        header: 'Ad Copy',
        synonyms: 'copy,text',
        definition: 'The copy shown on an ad',
        formatting: 'text',
    },
    adHeadline: {
        label: 'Ad Headline',
        header: 'Ad Headline',
        synonyms: 'headline',
        definition: 'The headline displayed on an ad',
        formatting: 'text',
    },
    landingPage: {
        label: 'Landing Page',
        header: 'Landing Page',
        synonyms: 'landing,page,lp',
        definition: 'The landing page for the ad',
        formatting: 'text',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_TAG_REFERENCE = {
    tag: {
        label: 'Tagged',
        synonyms: 'tag,tagging',
        definition: 'Tags applied to your ads within MagicBrief.',
        formatting: 'text',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_REFERENCE = {
    creativeType: {
        label: 'Creative Type',
        header: 'Creative Type',
        synonyms: 'type,image,video,carousel',
        definition: 'The type of asset used in the ad (image, video, carousel etc.).',
        enumerable: {
            image: 'Image',
            video: 'Video',
            carousel: 'Carousel',
            dynamic: 'Dynamic',
        },
        formatting: 'text',
    },
    effectiveStatus: {
        label: 'Delivery',
        header: 'Delivery',
        synonyms: 'active,paused,completed,live,delivery,running,stopped,cancelled',
        definition: 'The current status of your ad delivery.',
        enumerable: {
            Active: 'Active',
            Inactive: 'Inactive',
        },
        formatting: 'text',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_DATE_REFERENCE = {
    adCreatedAt: {
        label: 'Created At',
        header: 'Created At',
        definition: 'The date and time when the ad was created.',
        formatting: 'date',
    },
    adUpdatedAt: {
        label: 'Updated At',
        header: 'Updated At',
        definition: 'The date and time when the ad was last updated.',
        formatting: 'date',
    },
    adStartAt: {
        label: 'Start At',
        header: 'Start At',
        synonyms: 'begin',
        definition: 'The date your ad is/was scheduled to begin running.',
        formatting: 'date',
    },
    adEndAt: {
        label: 'End At',
        header: 'End At',
        synonyms: 'completed,finish',
        definition: 'The date your ad is/was scheduled to stop running.',
        formatting: 'date',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_REFERENCE = {
    wizardHookScore: {
        label: 'Hook Rate',
        header: 'Hook Rate',
        definition: "The ad's ability to stop a viewer scrolling on the feed.",
        formatting: 'numeric',
    },
    wizardHoldScore: {
        label: 'Hold Rate',
        header: 'Hold Rate',
        definition: "The ad's ability to keep a viewer engaged.",
        formatting: 'numeric',
    },
    wizardClickScore: {
        label: 'Click Rate',
        header: 'Click Rate',
        definition: "The ad's ability to drive viewers to your landing page.",
        formatting: 'numeric',
    },
    wizardBuyScore: {
        label: 'Buy Rate',
        header: 'Buy Rate',
        definition: "The ad's ability to drive purchases.",
        formatting: 'numeric',
    },
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_ALL_REFERENCE = {
    ...INSIGHTS_FACEBOOK_TIME_SERIES_ACTION_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_MULTI_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_TEXT_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_WIZARD_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_DATE_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_STANDARD_REFERENCE,
    ...INSIGHTS_FACEBOOK_TIME_SERIES_TAG_REFERENCE,
};
export const INSIGHTS_FACEBOOK_TIME_SERIES_DATE_OPERATIONS = [
    'is',
    'isnot',
    'before',
    'after',
    'btw',
    'nbtw',
    'withinDaysAgo',
    'withinWeeksAgo',
    'withinMonthsAgo',
    'withinYearsAgo',
    'withinDatePreset',
];
export const INSIGHTS_TIME_SERIES_DATE_OPERATIONS_V2 = [
    '=',
    '!=',
    '<',
    '>',
    'between',
    'notBetween',
    'withinLast',
    'withinDatePreset',
];
export const INSIGHTS_TIME_SERIES_TEXT_OPERATIONS = [
    'is',
    'isnot',
    'contains',
    'notcontains',
    'startsWith',
    'endsWith',
    'isSet',
    'isNotSet',
];
export const INSIGHTS_TIME_SERIES_TEXT_OPERATIONS_V2 = [
    '=',
    '!=',
    'contains',
    'notContains',
    'startsWith',
    'endsWith',
    'isSet',
    'isNotSet',
];
export const INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS = [
    'equals',
    'not',
    'gt',
    'gte',
    'lt',
    'lte',
    'btw',
    'nbtw',
];
export const INSIGHTS_TIME_SERIES_NUMERIC_OPERATIONS_V2 = [
    '=',
    '!=',
    '>',
    '>=',
    '<',
    '<=',
    'between',
    'notBetween',
];
export const INSIGHTS_TIME_SERIES_MULTI_OPTION_FIELD_OPERATIONS = [
    'in',
    'notIn',
];
export const INSIGHTS_TIME_SERIES_MULTI_OPTION_FIELD_OPERATIONS_V2 = [
    'in',
    'notIn',
];
export const INSIGHTS_TIME_SERIES_TAG_FIELD_OPERATIONS_V2 = [
    'in',
    'notIn',
];
const INSIGHTS_TIME_SERIES_METRIC_FORMATS = [
    'text',
    'date',
    'numeric',
    'currency',
    'percentage',
];
/** @see {@link https://developers.facebook.com/docs/marketing-api/insights/#attribution-windows} */
export const INSIGHTS_VIEW_ATTRIBUTION_WINDOWS = [
    '1d_view',
    '7d_view',
    '28d_view',
    '7d_view_first_conversion',
    '28d_view_first_conversion',
    '7d_view_all_conversions',
    '28d_view_all_conversions',
    'skan_view',
];
export const INSIGHTS_CLICK_ATTRIBUTION_WINDOWS = [
    '1d_click',
    '7d_click',
    '28d_click',
    'skan_click',
];
export const INSIGHTS_ENGAGED_VIEW_ATTRIBUTION_WINDOWS = ['1d_ev'];
export const INSIGHTS_FACEBOOK_GROUPS = [
    'adName',
    'headline',
    'copy',
    'creative',
    'asset',
    'landingPage',
    'true',
];
export const INSIGHTS_FACEBOOK_DATE_PRESETS = {
    today: 'today',
    yesterday: 'yesterday',
    // this_quarter: 'this_quarter',
    // data_maximum: 'data_maximum',
    last_3d: 'last_3d',
    last_7d: 'last_7d',
    this_week_sun_today: 'this_week_sun_today',
    // this_week_mon_today: 'this_week_mon_today',
    last_week_sun_sat: 'last_week_sun_sat',
    // last_week_mon_sun: 'last_week_mon_sun',
    last_14d: 'last_14d',
    last_28d: 'last_28d',
    last_30d: 'last_30d',
    this_month: 'this_month',
    last_month: 'last_month',
    // last_30d: 'last_30d',
    last_90d: 'last_90d',
    last_quarter: 'last_quarter',
    this_year: 'this_year',
    last_year: 'last_year',
    maximum: 'maximum',
};
// if `forTimePeriod` is custom in database, we manually figure the `since` and `until` out
export const INSIGHTS_FACEBOOK_CUSTOM_DATE_PRESETS = {
    last_365d: 'last_365d',
};
export const INSIGHTS_TIKTOK_DATE_PRESETS = {
    today: 'today',
    yesterday: 'yesterday',
    // this_quarter: 'this_quarter',
    // data_maximum: 'data_maximum',
    last_3d: 'last_3d',
    last_7d: 'last_7d',
    this_week_sun_today: 'this_week_sun_today',
    // this_week_mon_today: 'this_week_mon_today',
    last_week_sun_sat: 'last_week_sun_sat',
    // last_week_mon_sun: 'last_week_mon_sun',
    last_14d: 'last_14d',
    last_28d: 'last_28d',
    last_30d: 'last_30d',
    this_month: 'this_month',
    last_month: 'last_month',
    // last_30d: 'last_30d',
    // last_90d: 'last_90d',
    last_quarter: 'last_quarter',
    this_year: 'this_year',
    last_365d: 'last_365d',
};
export const INSIGHTS_FACEBOOK_SELECTABLE_DATE_PRESETS = {
    ...INSIGHTS_FACEBOOK_DATE_PRESETS,
    ...INSIGHTS_FACEBOOK_CUSTOM_DATE_PRESETS,
};
export const INSIGHTS_TIKTOK_SELECTABLE_DATE_PRESETS = {
    ...INSIGHTS_TIKTOK_DATE_PRESETS,
};
export const INSIGHTS_TABLE_COLOR_SCHEMAS = [
    'none',
    'positive-neutral',
    'neutral-negative',
    'positive-negative',
];
/**
 * The minimum spend requirement for ads to be conditionally highlighted in the Insights table.
 * This is to prevent low spend ads skewing the statistics of the ad set over the given filters.
 *
 * @example A low spend ad can have abornmally high ROAS and skew the analysis of actual top performing ads
 */
export const INSIGHTS_AD_SPEND_THRESHOLD = 50;
const INSIGHTS_FACEBOOK_CREATIVE_TYPES = [
    'carousel',
    'dynamic',
    'image',
    'video',
    'unknown',
];
export const INSIGHTS_TIME_SERIES_ALL_REFERENCE_BY_PLATFORM = {
    facebook: INSIGHTS_FACEBOOK_TIME_SERIES_ALL_REFERENCE,
    tiktok: INSIGHTS_TIKTOK_ALL_ATTRIBUTES_AND_METRICS_GLOSSARY,
};
export const INSIGHTS_REPORT_MAX_DESCRIPTION_LENGTH = 500;
//# sourceMappingURL=constants.js.map